import { TrueRoadblockType, TRoadblockChecklistItemType, TRoadblockType } from "../codecs/form/RoadblockForm";
import { pipe } from "fp-ts/lib/function";
import { array } from "fp-ts";
import { slRoadblockConfigs } from "./slRoadblockConfigs";

export type TRoadblockChecklistItemOption = {
    type: TRoadblockChecklistItemType;
    label: string;
};

const optionsByType: Map<TRoadblockType, Array<TRoadblockChecklistItemOption>> = (() => {
    const map = new Map<TRoadblockType, Array<TRoadblockChecklistItemOption>>();
    slRoadblockConfigs.forEach((roadblock) => {
        const seen = new Set<TRoadblockChecklistItemType>();
        const options = roadblock.checklist.reduce<Array<TRoadblockChecklistItemOption>>((acc, item) => {
            if (!seen.has(item.type)) {
                seen.add(item.type);
                acc.push({ type: item.type, label: item.is_resolved_by_short_description });
            }
            return acc;
        }, []);
        map.set(roadblock.type, options);
    });
    return map;
})();

export const getRoadblockChecklistItemOptions = (
    roadblockType: TRoadblockType,
): Array<TRoadblockChecklistItemOption> => optionsByType.get(roadblockType) ?? [];

export const roadblockTypeOptions: Array<TRoadblockType> = pipe(
    TrueRoadblockType.payload,
    array.map((literal) => literal.payload),
);
